import { toast } from "sonner";

const fallbackCopy = (text) => {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  const ok = document.execCommand("copy");
  document.body.removeChild(ta);
  return ok;
};

export const copyText = async (text, label = "Clé copiée") => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
    } else if (!fallbackCopy(text)) {
      throw new Error("copy");
    }
    toast.success(label);
  } catch {
    if (fallbackCopy(text)) { toast.success(label); } else { toast.error("Copie impossible, sélectionnez la clé manuellement"); }
  }
};
